import { getRoleKey, useGetRole, useUpdateRole } from 'api-hooks/role';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useDialog from 'hooks/use-dialog';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import RoleForm from './components/form';
import RoleDuplicateDialog from './components/role-duplicate-dialog';

export type RoleViewParams = {
  id: string;
};

export default function RoleView(
  props: NavigationProps<NavigationRoutes.RolesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetRole({
    id,
  });
  const { mutateAsync, error: mutateError } = useUpdateRole();
  const dialog = useDialog();

  const role = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!mutateError && !!mutateError.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => mutateError.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}
          <RoleForm
            {...props}
            role={role}
            onSubmit={async (input, form) => {
              dialog.showCustom({
                render: (dismiss) => (
                  <RoleDuplicateDialog
                    onClose={dismiss}
                    previousValues={input}
                    onPositivePress={async () => {
                      const result = await mutateAsync({
                        body: input,
                        roleId: role!.id,
                      });

                      queryClient.refetchQueries(getRoleKey({ id: role!.id }));
                      notification.success({ message: result?.message });
                      dismiss();
                    }}
                  />
                ),
              });

              return undefined;
            }}
          />
        </>
      }
    />
  );
}
